var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrrowColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1415 6.70415C11.9075 6.83039 11.7616 7.07044 11.7616 7.33152V11.397H3.73429C3.32896 11.397 3 11.7183 3 12.1142C3 12.5102 3.32896 12.8315 3.73429 12.8315H11.7616V16.8969C11.7616 17.159 11.9075 17.399 12.1415 17.5243C12.3755 17.6515 12.6614 17.6429 12.8875 17.5042L20.6573 12.7215C20.8708 12.5895 21 12.361 21 12.1142C21 11.8675 20.8708 11.6389 20.6573 11.5069L12.8875 6.72424C12.7681 6.65156 12.632 6.61426 12.4959 6.61426C12.3745 6.61426 12.2521 6.64486 12.1415 6.70415Z",
    fill: "#151310"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrowColored);
export default __webpack_public_path__ + "static/media/arrrow_colored.9399ab2c826107b26234d06266908142.svg";
export { ForwardRef as ReactComponent };